import React from 'react';
import { Button, Card } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PaymentLinkForm from './PaymentLinkForm';
import RecordPaymentForm from './RecordPaymentForm';
import SettlementForm from './SettlementForm';
import LedgerActionForm from './LedgerActionForm';
import UnlockBlockers from './UnlockBlockers';
const TITLES = {
  link: 'Send payment link', record: 'Record payment', cheque: 'Record cheque', settlement: 'Pay later / COD',
  change_terms: 'Change terms', request_settlement_change: 'Ask Accounts to change', glossary: 'Payment glossary',
  unlock: 'Unlock invoice', unlock_blocked: 'Why the invoice is locked', cancel_link: 'Cancel link', resend_link: 'Resend link', refund: 'Request refund',
  reverse: 'Reverse whole receipt', withdraw_report: 'Withdraw report', cancel_expected_cheque: 'Cancel expected cheque',
};
const GLOSSARY = [
  ['Paid', 'Cleared money received against the invoice.'],
  ['Payment link', 'A collection request. It is not money received until the provider confirms it.'],
  ['Bank / POS report', 'Waits for Accounts to verify before it counts as paid.'],
  ['Pay later / COD', 'A promise to pay later, not money received.'],
  ['Reversal', 'Corrects a receipt that was recorded by mistake.'],
  ['Refund', 'Money returned to the customer, recorded separately.'],
];
export const actionTitle = key => TITLES[key] || key.replaceAll('_', ' ');
export default function PaymentActionPanel({ action, projection, reload, onClose, onAction, onRevisePrice = null }) {
  const props = { projection, reload };
  const arrangement = projection.settlement_arrangements?.find(row => String(row.id) === String(action.row?.entity_id));
  let content;
  if (action.key === 'link') content = <PaymentLinkForm {...props} queryPk={projection.query_pk} />;
  else if (action.key === 'record' || action.key === 'cheque') content = <RecordPaymentForm {...props} chequeOnly={action.key === 'cheque'} />;
  else if (['settlement', 'change_terms', 'request_settlement_change'].includes(action.key)) content = <SettlementForm {...props} row={arrangement} mode={action.key} onRequestChange={() => onAction({ key: 'request_settlement_change', row: action.row })} />;
  else if (action.key === 'glossary') content = <dl className="pv2-glossary">{GLOSSARY.map(([term, meaning]) => <React.Fragment key={term}><dt>{term}</dt><dd>{meaning}</dd></React.Fragment>)}</dl>;
  else if (action.key === 'unlock_blocked') content = <UnlockBlockers projection={projection} onRevisePrice={onRevisePrice} />;
  else if (action.key === 'changed_mind') return null;
  else content = <LedgerActionForm {...props} action={action} />;
  return <Card size="small" title={actionTitle(action.key)} extra={<Button type="text" size="small" aria-label="Close" icon={<CloseOutlined />} onClick={onClose} />}>{content}</Card>;
}
